import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShieldCheckBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7540_5588)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M60.2627 109.715C60.0907 109.762 59.9093 109.762 59.7373 109.715L60 108.75L60.2627 109.715ZM100.25 26.25C100.25 25.5207 99.9601 24.8214 99.4443 24.3057C98.9286 23.7899 98.2293 23.5 97.5 23.5H22.5C21.7707 23.5 21.0714 23.7899 20.5557 24.3057C20.0399 24.8214 19.75 25.5207 19.75 26.25V52.5C19.75 74.6432 29.88 88.439 40.0078 96.7256C45.0817 100.877 50.1598 103.648 53.9688 105.379C55.872 106.244 57.4554 106.849 58.5586 107.235C59.11 107.429 59.5412 107.567 59.832 107.657C59.8944 107.677 59.9507 107.692 60 107.707C60.0493 107.692 60.1056 107.677 60.168 107.657C60.4588 107.567 60.89 107.429 61.4414 107.235C62.5446 106.849 64.128 106.244 66.0312 105.379C69.8402 103.648 74.9183 100.877 79.9922 96.7256C90.12 88.439 100.25 74.6432 100.25 52.5V26.25ZM102.25 52.5C102.25 75.3564 91.7549 89.6859 81.2578 98.2744C76.0195 102.56 70.7847 105.415 66.8594 107.199C64.8957 108.092 63.2561 108.718 62.1035 109.122C61.5272 109.324 61.0722 109.471 60.7588 109.568C60.6023 109.617 60.4809 109.653 60.3975 109.677C60.3558 109.689 60.3232 109.698 60.3008 109.704C60.2896 109.707 60.2807 109.71 60.2744 109.712C60.2713 109.713 60.2685 109.713 60.2666 109.714L60.2646 109.715C60.2639 109.715 60.2618 109.71 60 108.75C59.7382 109.71 59.7361 109.715 59.7354 109.715L59.7334 109.714C59.7315 109.713 59.7287 109.713 59.7256 109.712C59.7193 109.71 59.7104 109.707 59.6992 109.704C59.6768 109.698 59.6442 109.689 59.6025 109.677C59.5191 109.653 59.3977 109.617 59.2412 109.568C58.9278 109.471 58.4728 109.324 57.8965 109.122C56.7439 108.718 55.1043 108.092 53.1406 107.199C49.2153 105.415 43.9805 102.56 38.7422 98.2744C28.2451 89.6859 17.75 75.3564 17.75 52.5V26.25C17.75 24.9902 18.2508 23.7824 19.1416 22.8916C20.0324 22.0008 21.2402 21.5 22.5 21.5H97.5C98.7598 21.5 99.9676 22.0008 100.858 22.8916C101.749 23.7824 102.25 24.9902 102.25 26.25V52.5Z",
			fill: "#14151F"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M78.0429 48.0429C78.4334 47.6524 79.0664 47.6524 79.457 48.0429C79.8475 48.4334 79.8475 49.0664 79.457 49.457L53.207 75.707C52.8164 76.0975 52.1834 76.0975 51.7929 75.707L40.5429 64.457C40.1524 64.0664 40.1524 63.4334 40.5429 63.0429C40.9334 62.6524 41.5664 62.6524 41.957 63.0429L52.4999 73.5859L78.0429 48.0429Z",
			fill: "url(#paint0_linear_7540_5588)"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_7540_5588",
		x1: 40.25,
		y1: 75.9998,
		x2: 84.2344,
		y2: 60.3711,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#E45D96"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7540_5588",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 120,
			height: 120,
			fill: "white"
		})
	})] })]
});
export default SvgShieldCheckBig;
